import React, { useEffect } from "react";
import { useInView } from "react-intersection-observer";
import { motion, useAnimation } from "framer-motion";

function FadeInWhenVisible({ children }) {
  const controls = useAnimation();
  const [ref, inView] = useInView();

  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
    return () => controls.start("hidden");
  }, [controls, inView]);

  return (
    <motion.div
      ref={ref}
      // animate={controls}
      animate={controls}
      initial="hidden"
      transition={{ duration: 1.2 }}
      variants={{
        visible: { opacity: 1, scale: 1 },
        hidden: { opacity: 0, scale: 0 },
      }}
    >
      {children}
    </motion.div>
  );
}

export default FadeInWhenVisible;
